// Çalışan Analizi tablosunun sütunları: çalışan başına bir satır (eski gruplu
// tablonun ana satırı). Süzgeç anahtarları eski tablonunkiler: employee,
// project, role. Metinler: employeeAnalysis.columns.<key>.

export const ANALYSIS_COLUMNS = {
  employee: { type: 'text', width: 250 },
  project: { type: 'text', width: 260 },
  role: { type: 'text', width: 260 },
  visits: { width: 140 },
  expense: { width: 170 },
};

export const COLUMN_KEYS = Object.keys(ANALYSIS_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, true]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['employee'];
export const FILTER_KEYS = ['employee', 'project', 'role'];
export const SORT_KEYS = ['name', 'projects', 'visits', 'expense'];

export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
